import React from "react";
import "./index.css";
import { CustomMenu, QuantityMap } from "../../../../../redux/allocationService";
import { CustomMenuRow } from "./CustomMenuRow";
import "../SetMenuSection/index.css";

interface CustomMenuSectionProps {
  menus: CustomMenu[];
  quantities: QuantityMap;
  onQuantityChange: (key: string, value: number) => void;
}

export const CustomMenuSection: React.FC<CustomMenuSectionProps> = ({
  menus,
  quantities,
  onQuantityChange,
}) => {

  let rowIndex = 1;

  return (
    <section className="packs-section">
      <div className="packs-section__header">
        <div className="packs-section__bar packs-section__bar--custom" />
        <span className="packs-section__title">Custom Menus</span>
        <div className="packs-section__line" />
      </div>
      <div className="packs-section__rows">
        {menus.map((menu) => (
          <CustomMenuRow
            key={menu.itemId}
            menu={menu}
            index={rowIndex++}
            quantities={quantities}
            onQuantityChange={onQuantityChange}
          />
        ))}
      </div>
    </section>
  );
};